
import { defineComponent } from "vue";
import { mapState } from "vuex";

import ProductItem from "./ProductItem.vue";
import ProgressBar from "./../common/ProgressBar.vue";

export default defineComponent({
    name: "ProductList",
    components: {
        ProductItem,
        ProgressBar
    },
    computed: {
        ...mapState(['product'])
    }
});
